import BugReportModal from "./Container";

export default BugReportModal;
